import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Preload from "./components/Preloader/Preload"; // Import Preload component

const root = ReactDOM.createRoot(document.getElementById("root"));

const Root = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading process, adjust timeout as necessary
    const timer = setTimeout(() => {
      setIsLoading(false); // After 2 seconds, hide the preloader and show the app
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timeout if the component unmounts
  }, []);

  return (
    <>
      {isLoading ? <Preload /> : null} {/* Show preloader if loading */}
      <BrowserRouter>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </BrowserRouter>
    </>
  );
};

root.render(<Root />);
